import {useAuthStore} from "@/stores/auth.store";
import type {RouteLocationNormalized} from "vue-router";
import routingConstants from "@/router/routingConstants";
import OnboardingStatus from "@/models/constants/onboardingStatus";


export default async function routeGuard(to: RouteLocationNormalized, from: RouteLocationNormalized)  {
    let authStore = useAuthStore();

    if(to.hash !== "")
        return to.path;

    console.log(`checking authentication: ${authStore.authenticated()}, superAdmin: ${authStore.isSuperAdmin()}, path: ${to.path}, onboarding: ${authStore.user.onboardingStatus}`);
    console.log(`${from.path} => ${to.path}`);
    console.log(`Route meta: ${JSON.stringify(to.meta)}`);

    // Step 1: Check if route allows anonymous access
    if (to.meta.allowAnonymous) {
        return true;
    }

    // Step 2: Check if user is authenticated
    if (!authStore.authenticated()) {
        await authStore.login(to.path);
    }

    // Step 5: Authenticated user tries to log in again or access onboarding when completed
    return authenticatedProtectedRedirect(to, from);
}

function authenticatedProtectedRedirect(to: RouteLocationNormalized, from: RouteLocationNormalized) {
    let authStore = useAuthStore();

    // Redirect authenticated users away from login page
    if (to.path === routingConstants.loginRoute || to.path == "/") {
        if(authStore.isSuperAdmin() || authStore.isAdmin())
            return routingConstants.defaultSuperAdminRoute;
        else
            return routingConstants.defaultAuthenticatedRoute;
    }

    // Step 3: User is authenticated, check for superAdmin requirement
    if (to.meta.requiresSuperAdmin && (!authStore.isSuperAdmin() && !authStore.isAdmin())) {
        console.log("Route requires super admin privileges, redirecting to dashboard");
        return routingConstants.defaultAuthenticatedRoute;
    }

    // Step 3b: Developer-only routes (defense-in-depth; the API enforces the DeveloperToken policy)
    if (to.meta.requiresDeveloper && !authStore.isDeveloper()) {
        console.log("Route requires developer privileges, redirecting to dashboard");
        return routingConstants.defaultAuthenticatedRoute;
    }

    // Step 4: Check onboarding requirements
    if (to.meta.requiresOnboarding && (
        authStore.user.onboardingStatus === OnboardingStatus.NotStarted ||
        authStore.user.onboardingStatus === OnboardingStatus.PersonalDataCompleted)
    ) {
        // Onboarding flow runs on a separate app domain.
        window.location.href = import.meta.env.VITE_DASHBOARD_BASE_URI;
        return false;
    }

    // Prevent accessing onboarding when already completed
    if (to.meta.requiresNotOnboarded && (
        authStore.user.onboardingStatus === OnboardingStatus.MeteringPointsSelected
        || authStore.user.onboardingStatus === OnboardingStatus.EnergyCommunitySelected)) {
        return routingConstants.dashboardRoute;
    }

    return true;
}